import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuModalComponent } from '../menu-modal/menu-modal.component'; // გზა სწორად მიუთითე

@Component({
  selector: 'app-menu-item',
  imports: [CommonModule, FormsModule, DragDropModule],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.css'
})
export class MenuItemComponent {
  @Input() item!: any;
  @Input() allMenu: any[] = [];
  @Output() update = new EventEmitter<void>();

  showChildren = false;

  @Output() dragChanged = new EventEmitter<boolean>();

  constructor(private modalService: NgbModal) {
   
  }
  
  // addChild() {
  //   const newChild = {
  //     id: Date.now(), // დროებითი ID
  //     title: 'ახალი ქვეპუნქტი',
  //     children: [] as any[]
  //   };
  //   this.item.children.push(newChild);
  //   this.update.emit();
  // }

  deleteItem() {
    // პირდაპირ მშობელიდან უნდა წაიშალოს
  }

dropChild(event: CdkDragDrop<any[]>) {
  // გადაადგილება children-ის მასივში
  moveItemInArray(this.item.children, event.previousIndex, event.currentIndex);

  // დაემატოს ახალი sort value
  this.item.children.forEach((child: any, index: number) => {
    child.sort = index + 1;
  });


  // notify parent component that drag has changed
  this.dragChanged.emit(true);

  // notify parent to save changes
  this.update.emit();
}

openEditModal() {
  const modalRef = this.modalService.open(MenuModalComponent, { size: 'lg' });

  modalRef.componentInstance.menuItem = { ...this.item };

  // Pass full menu list if needed
  modalRef.componentInstance.allMenu = this.allMenu;

  modalRef.result.then((result) => {
    if (result) {
      this.item.menutitle = result.menutitle;
      this.item.visibility = result.visibility;
      this.update.emit();
    }
  }).catch(() => {});
}

}
